 <template>
    <el-select
        @change="SelectChange"
        v-model="selectValue"
        size="mini"
        :style="{ width: width, margin: margin }"
        placeholder="请选择工单模板/类型"
        filterable>
        <el-option v-for="(item, idx) in select" :key="idx" :label="item.name"  :value="item.id"></el-option>
    </el-select>
</template>
<script>
export default {
    props: {
        value: {
            type: Number,
            default: null
        },
        width: {
            type: String,
            default: '100%'
        },
        margin: {
            type: String,
            default: '0px'
        },
    },
    watch: {
        value () {
            this.selectValue = this.value
        }
    },
    data () {
        return {
            select: [],
            selectValue: null,
        }
    },
    mounted () {
        this.$http.post('/9api/wo-template/search').then(rps => {
            this.select = rps.data
        })
    },
    methods: {
        SelectChange(id) {
            this.$emit('input', id)
            this.$emit('onChange', this.select.filter(item => item.id == id)[0])
        }
    }
}
</script>